import React from "react";
import { withStyles } from "@material-ui/core/styles";
import {
  Select,
  MenuItem,
  TextField,
  IconButton,
  Typography,
  Grid,
  Menu,
  Card,
  CardHeader,
  CardContent,
  Divider,
  Button,
  Snackbar,
  List,
  ListItem,
  ListItemSecondaryAction,
  FormControl,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";

import LocationOnIcon from "@material-ui/icons/LocationOn";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ConfirmDeleteDialog from "./AlertDialog";
import MySnackbarContentWrapper from "./MySnackbarContentWrapper";
import Vn2000 from "../helper/Vn2000";
import MoreVertIcon from "@material-ui/icons/MoreVert";

const styles = (theme) => ({
  formControl: {
    marginTop: "5px",
    marginBottom: "5px",
  },
  fullHeight: {
    height: "100%",
  },
  locationForm: {
    height: "100%",
    overflowY: "auto",
    zIndex: 2,
  },
  point: {
    paddingLeft: '0px',
    paddingRight: '10px'
  },
  pointInfo: {
    width: '100%',
    overflow: 'hidden !important',
    textOverflow: 'ellipsis'
  },
  pointList:{
    listStyle: 'none',
    paddingLeft: '0px'
  },
  pointTitle:{
    fontWeight: 'bold'
  },
  pointMenu:{
    right: '0px',
    top: '10px'
  },
  positionIcon: {
    padding: 0,
    borderBottom: '1px solid #ccc',
    paddingBottom: '5px',
    paddingTop: '5px',
    marginTop: '5px'
  },
});
class AdjustForm extends React.Component {
  constructor(props) {
    super(props);
    const { formValues, layout } = props;
    this.state = {
      formValues,
      layout,
    };
  }
  _convertXY = () => {
    const { formValues } = this.state;
    const { x, y, provinceValue } = formValues;

    const xValue = Number.parseFloat(x);
    const yValue = Number.parseFloat(y);
    const isError = Number.isNaN(xValue) || Number.isNaN(yValue);
    if (isError) {
      this.setState({
        formValues: {
          ...formValues,
          isError: true,
          errorMessage: "Vui lòng kiểm tra giá trị X hay Y",
        },
      });
    } else {
      const fromProjection = Vn2000.provinces.find(
        (p) => p.id === provinceValue
      );
      const result = Vn2000.vn2000ToWGG84(xValue, yValue, fromProjection.value);
      this.setState({
        formValues: {
          ...formValues,
          isError: false,
          errorMessage: "",
          longitude: result.longitude,
          latitude: result.latitude,
        },
      });
    }
  };
  _onProviceChange = (event) => {
    const value = event.target.value;

    const { formValues } = this.state;

    this.setState({
      formValues: { ...formValues, provinceValue: value },
    });
  };
  _onXUpdated = (e) => {
    const { formValues } = this.state;

    this.setState({
      formValues: { ...formValues, x: e.target.value },
    });
  };
  _onYUpdated = (e) => {
    const { formValues } = this.state;

    this.setState({
      formValues: { ...formValues, y: e.target.value },
    });
  };
  _onLongitudeUpdated = (e) => {
    const { formValues } = this.state;

    this.setState({
      formValues: { ...formValues, longitude: e.target.value },
    });
  };

  _onLatitudeUpdated = (e) => {
    const { formValues } = this.state;

    this.setState({
      formValues: { ...formValues, latitude: e.target.value },
    });
  };

  _onTrackingChange = (event) => {
    const { formValues } = this.state;
    this.setState({
      formValues: { ...formValues, tracking: event.target.checked },
    });
  };

  _onUpdated = (e) => {
    const { formValues } = this.state;

    this.setState({
      formValues: { ...formValues, y: e.target.value },
    });
  };

  _onFormValueErrorClose = () => {
    const { formValues } = this.state;

    this.setState({
      formValues: { ...formValues, isError: false },
    });
  };

  _onDeletePosition = (item) => {
    const { formValues } = this.state;
    this.updateData({
      ...formValues,
      deleteItem: item,
      isDeleteDialogOpen: true,
    });
  };

  _onUpPosition = (item) => {
    const { formValues } = this.state;
    const { data } = formValues;
    const index = data.positions.findIndex((it) => it.id === item.id);
    var changeIndex = index - 1;
    this._onDownPosition(data.positions[changeIndex]);
    this.updateData(formValues);
  };

  _onDownPosition = (item) => {
    const { formValues } = this.state;
    const { data } = formValues;

    const index = data.positions.findIndex((it) => it.id === item.id);
    const changeIndex = index + 1;
    data.positions.splice(index, 1);
    data.positions.splice(changeIndex, 0, item);
    this.updateData({ ...formValues, data: data, anchorEl: null });
  };

  _onConfirmDialogClose = (isConfirm) => {
    const { formValues } = this.state;
    if (isConfirm) {
      const { data, deleteItem } = formValues;
      const index = data.positions.findIndex((it) => it.id === deleteItem.id);
      data.positions.splice(index, 1);
    }
    this.updateData({
      ...formValues,
      deleteItem: null,
      isDeleteDialogOpen: false,
      anchorEl: null,
    });
  };
  _onMenuPositionClick = (event, item) => {
    const { formValues } = this.state;
    this.setState({
      formValues: {
        ...formValues,
        anchorEl: event.currentTarget,
        menuSelected: item,
      },
    });
  };
  _onMenuPositionClose = () => {
    const { formValues } = this.state;
    this.setState({
      formValues: { ...formValues, anchorEl: null },
    });
  };
  _onAddPosition = () => {
    const { formValues } = this.state;
    const { longitude, latitude } = formValues;
    const xValue = Number.parseFloat(longitude);
    const yValue = Number.parseFloat(latitude);
    const isLongitudeValid = !Number.isNaN(xValue) && Number.isFinite(xValue);
    const isLatituteValid =
      !Number.isNaN(yValue) &&
      Number.isFinite(yValue) &&
      yValue >= -90 &&
      yValue <= 90;
    const isError = !isLongitudeValid || !isLatituteValid;

    if (isError) {
      this.setState({
        formValues: {
          ...formValues,
          isError: true,
          errorMessage: "Vui lòng kiểm tra giá trị longitude hay latitude",
        },
      });
      return;
    }
    const newPosition = {
      longitude: xValue,
      latitude: yValue,
      id: formValues.data.positions.length + 1,
    };
    formValues.data.positions.push(newPosition);

    this.updateData({
      ...formValues,
      isError: false,
      errorMessage: "",
      longitude: "",
      latitude: "",
      x: "",
      y: "",
    });
  };
  updateData(formValues) {
    this.setState({
      formValues,
    });
    const { onUpdateValues } = this.props;
    if (onUpdateValues) {
      onUpdateValues(formValues);
    }
  }
  _setMapLocation = (longitude, latitude) => {
    const { onSetLocation } = this.props;
    if (onSetLocation) {
      onSetLocation(longitude, latitude);
    }
  };
  render() {
    const { classes, marker, onColapsed, layout } = this.props;
    const { formValues } = this.state;
    return (
      <Grid
        className={classes.fullHeight}
        item
        xs={layout.xs}
        sm={layout.sm}
        md={layout.md}
      >
        <Card className={classes.locationForm}>
          <CardHeader
            title="Chuyển tọa độ"
            action={
              <IconButton aria-label="settings" onClick={onColapsed}>
                <ChevronLeftIcon />
              </IconButton>
            }
          />
          <CardContent>
            <FormControl fullWidth={true} className={classes.formControl}>
              <Typography
                className={classes.mainPoint}
                variant="h5"
                component="h5"
              >
                Vị trí chính
              </Typography>
            </FormControl>
            <FormControl fullWidth={true} className={classes.formControl}>
              <Typography variant="body2" color="textSecondary" component="p">
                Latitude : {Vn2000.formatLongLat(marker.latitude)}
              </Typography>
            </FormControl>
            <FormControl fullWidth={true} className={classes.formControl}>
              <Typography variant="body2" color="textSecondary" component="p">
                Longitude : {Vn2000.formatLongLat(marker.longitude)}
              </Typography>
            </FormControl>
            <FormControl fullWidth={true} className={classes.formControl}>
              <Select
                className={classes.paddingTop10}
                value={formValues.provinceValue}
                onChange={this._onProviceChange}
                fullWidth={true}
              >
                {Vn2000.provinces.map((province) => {
                  return (
                    <MenuItem value={province.id} key={province.id}>
                      {province.name}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
            <FormControl fullWidth={true} className={classes.formControl}>
              <TextField
                label="X"
                value={formValues.x}
                onChange={this._onXUpdated}
                fullWidth={true}
              />
            </FormControl>
            <FormControl fullWidth={true} className={classes.formControl}>
              <TextField
                label="Y"
                value={formValues.y}
                onChange={this._onYUpdated}
                fullWidth={true}
              />
            </FormControl>
            <FormControl className={classes.formControl}>
              <Button
                size="small"
                variant="outlined"
                color="secondary"
                className={classes.margin}
                onClick={this._convertXY}
                fullWidth={true}
              >
                Chuyển
              </Button>
            </FormControl>
            <FormControl fullWidth={true} className={classes.formControl}>
              <TextField
                label="Latitude"
                value={formValues.latitude}
                onChange={this._onLatitudeUpdated}
                fullWidth={true}
              />
            </FormControl>
            <FormControl fullWidth={true} className={classes.formControl}>
              <TextField
                label="Longitude"
                value={formValues.longitude}
                onChange={this._onLongitudeUpdated}
                fullWidth={true}
              />
            </FormControl>
            <FormControl fullWidth={true} className={classes.formControl}>
              <Button
                size="small"
                variant="contained"
                color="secondary"
                className={classes.margin}
                onClick={this._onAddPosition}
              >
                Thêm vị trí
              </Button>
            </FormControl>

            <Divider />

            <List className={classes.point}>
              {formValues.data.positions.map((p, idx) => {
                const isOpen =
                  Boolean(formValues.anchorEl) &&
                  formValues.menuSelected.id === p.id;
                return (
                  <ListItem 
                    className={classes.positionIcon} 
                    key={p.id}>
                    <div className={classes.pointInfo}> 
                      <ul className={classes.pointList}>
                        <li className={classes.pointTitle}>{p.id}</li>
                        <li>Latitude: {p.latitude}</li>
                        <li>Longitude: {p.longitude}</li>
                      </ul>
                    </div>

                    <ListItemSecondaryAction 
                    className={classes.pointMenu}>
                      <IconButton
                        onClick={(e) => this._onMenuPositionClick(e, p)}
                      >
                        <MoreVertIcon />
                      </IconButton>
                      <Menu
                        anchorEl={formValues.anchorEl}
                        open={isOpen}
                        onClose={this._onMenuPositionClose}
                      >
                        {idx !== 0 ? (
                          <MenuItem onClick={() => this._onUpPosition(p, idx)}>
                            <KeyboardArrowUpIcon /> Lên
                          </MenuItem>
                        ) : null}
                        {idx !== formValues.data.positions.length - 1 ? (
                          <MenuItem
                            onClick={() => this._onDownPosition(p, idx)}
                          >
                            <KeyboardArrowDownIcon /> Xuống
                          </MenuItem>
                        ) : null}

                        <MenuItem
                          onClick={() =>
                            this._setMapLocation(p.longitude, p.latitude)
                          }
                        >
                          <LocationOnIcon /> Định vị
                        </MenuItem>

                        <MenuItem
                          onClick={() => this._onDeletePosition(p, idx)}
                        >
                          <DeleteIcon /> Xóa
                        </MenuItem>
                      </Menu>
                    </ListItemSecondaryAction>
                  </ListItem>
                );
              })}
            </List>
          </CardContent>

          <ConfirmDeleteDialog
            onDialogClose={this._onConfirmDialogClose}
            isOpen={formValues.isDeleteDialogOpen}
            title="Xóa vị trí"
            text="Bạn chắc rằng muốn xóa vị trí này"
          ></ConfirmDeleteDialog>

          <Snackbar
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "center",
            }}
            open={formValues.isError}
            autoHideDuration={6000}
            onClose={this._onFormValueErrorClose}
          >
            <MySnackbarContentWrapper
              onClose={this._onFormValueErrorClose}
              variant="error"
              message={formValues.errorMessage}
            />
          </Snackbar>
          <Divider />
        </Card>
      </Grid>
    );
  }
}
export default withStyles(styles)(AdjustForm);
